import React from "react";
import styled from "styled-components";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import Select from "react-select";
import analyticsLogo from "../AccountDetails/analytics-logo.png";
import { NoGAConnected } from "./GoogleAnalyticsSettings/SelectSubModules";
import { portalledMenu } from "./portalledMenu";

const Row = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

const TokenRow = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 2px 0;
    font-size: 0.875rem;
    color: #0f172a;
    font-family: "Inter", system-ui, sans-serif;
`;

const AnalyticsToken = ({ token }) => (
    <TokenRow>
        <img src={analyticsLogo} alt="" width={18} height={18} />
        {token.analyticsAccountOwner}
    </TokenRow>
);

const IconBtn = styled.button`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 34px;
    border: 1px solid #e2e8f0;
    border-radius: 7px;
    background: #fff;
    color: #64748b;
    cursor: pointer;
    flex-shrink: 0;
    font-size: 1rem;
    transition: background 120ms, color 120ms;
    &:hover { background: #f8fafc; color: #0f172a; }
`;

export function tokenOption(token) {
    return {
        value: token.name,
        label: <AnalyticsToken token={token} />,
        id: token.id,
        analyticsAccountOwner: token.analyticsAccountOwner,
    };
}

// The one Google connection both Analytics and Search Console are read through, so both settings
// sections pick it the same way: the same list, the same button to connect another account and the
// same button to manage the connected ones.
export const GoogleAccountSelect = ({ value, onChange, isClearable, isDisabled, redirectUrl }) => {
    const analyticsTokens = useSelector(s => s.login.userDetails.analyticsTokens) || [];
    const history = useHistory();

    const options = analyticsTokens.map(tokenOption);

    return (
        <Row>
            <div style={{ flex: 1 }}>
                <Select
                    {...portalledMenu}
                    isClearable={isClearable}
                    isDisabled={isDisabled}
                    value={value}
                    onChange={onChange}
                    options={options}
                    components={{ NoOptionsMessage: NoGAConnected({}, connectAccount) }}
                    placeholder="Select a Google account…"
                />
            </div>
            <IconBtn onClick={connectAccount} title="Connect another account">+</IconBtn>
            <IconBtn onClick={() => history.push("/account/google-analytics")} title="Manage accounts">⋯</IconBtn>
        </Row>
    );

    function connectAccount() {
        window.location.href = "/api/google/authorize?redirectUrl="
            + encodeURIComponent(redirectUrl || window.location.href);
    }
};
